import React from "react";
import Logo from "../assets/svg/avease_logo_color.svg?react";
import { checkAuthentication } from "../store";
import { Navigate } from "react-router-dom";

export default function AuthLayout({ children }) {
  const isAuthenticated = checkAuthentication();

  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <div className="relative grid lg:grid-cols-3 min-h-screen bg-primary lg:bg-white-smoke">
      <div className="hidden lg:block lg:col-span-2 from-av-dark-red via-primary to-primary bg-gradient-to-tr bg-black/20 bg-blend-multiply" />
      <div className="lg:absolute inset-0 grid lg:grid-cols-2 gap-4 self-center max-w-[1600px] lg:w-4/5 w-full mx-auto my-10 lg:my-0">
        <div className="flex flex-col items-center justify-center lg:items-start lg:justify-between h-full lg:h-[450px] lg:pl-12">
          {/* logo pinned to top on lg, centered on mobile */}
          <Logo className=" text-white  lg:self-start" />

          {/* small-screen: visible under logo and centered; large-screen: pinned to bottom and left-aligned */}
          <p className="mt-6 lg:mt-0 text-2xl sm:text-3xl p-3 lg:text-5xl font-extrabold text-white text-center lg:text-left">
            Welcome to the
            <br /> Avease Vendor Portal!
          </p>
        </div>

        <div className="bg-white p-10 rounded-[20px] max-w-[440px] w-full mx-auto lg:mx-0 self-center">
          {children}
        </div>
      </div>
    </div>
  );
}
